import { render, staticRenderFns } from "./MatchingPhonics2Form.vue?vue&type=template&id=1aeefc56&"
import script from "./MatchingPhonics2Form.vue?vue&type=script&lang=js&"
export * from "./MatchingPhonics2Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports